import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutTop: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-top, margin, padding"><path d="M3 7.75C3 7.55109 3.07907 7.36038 3.21973 7.21973C3.36038 7.07907 3.55109 7 3.75 7H20.25C20.6642 7 21 7.33579 21 7.75V20.25C21 20.4489 20.9209 20.6396 20.7803 20.7803C20.6396 20.9209 20.4489 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25V7.75Z" fill="currentColor"/><path d="M3 3.75C3 3.33579 3.33579 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75C21 4.16421 20.6642 4.5 20.25 4.5H3.75C3.33579 4.5 3 4.16421 3 3.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLayoutTop;
